import { Linkedin, Twitter, Facebook, Instagram, Phone, Mail, MapPin } from "lucide-react";

const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Krijo", href: "#why-krijo" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

const SERVICES = [
  "Talent Recruitment & Staffing",
  "Recruitment Process Outsourcing",
  "HR Strategy & Compliance",
  "Custom Software Development",
  "ERP Implementation (ERPNext)",
  "Business Automation Solutions",
];

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com" },
  { icon: Twitter, label: "Twitter", href: "https://www.twitter.com" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/8 bg-[#010330] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a href="#home" data-testid="footer-logo" className="flex items-center gap-3">
              <img src="/krijo-logo.png" alt="Krijo Consultancy Services logo" className="h-12 w-12 rounded-lg object-cover" />
              <span className="font-['Poppins'] font-semibold leading-tight">
                Krijo
                <span className="block text-[9px] font-medium tracking-[0.25em] text-[#F89335] uppercase">Consultancy Services</span>
              </span>
            </a>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              Empowering businesses through people and technology — end-to-end HR solutions and software services.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="w-10 h-10 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-slate-300 hover:text-[#F89335] hover:border-[#F89335]/50 transition-colors duration-200"
                >
                  <s.icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-['Poppins'] font-semibold text-sm uppercase tracking-wider text-white">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-400 hover:text-[#F89335] transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-['Poppins'] font-semibold text-sm uppercase tracking-wider text-white">Services</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s}>
                  <a href="#services" className="text-sm text-slate-400 hover:text-[#F89335] transition-colors duration-200">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-['Poppins'] font-semibold text-sm uppercase tracking-wider text-white">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#F89335] mt-0.5 shrink-0" />
                <a href="tel:+919880465477" data-testid="footer-phone" className="hover:text-[#F89335] transition-colors">+91 98804 65477</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#F89335] mt-0.5 shrink-0" />
                <a href="mailto:info@krijotech.com" data-testid="footer-email" className="hover:text-[#F89335] transition-colors">info@krijotech.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#F89335] mt-0.5 shrink-0" />
                <span data-testid="footer-address">India — serving clients nationwide & globally</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-copyright" className="text-xs text-slate-500">
            © {new Date().getFullYear()} Krijo Consultancy Services. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">People. Technology. Partnership.</p>
        </div>
      </div>
    </footer>
  );
}
